import React, { useState, useEffect } from "react";
import "../Principle/Assessts/Styles/PrincipleDashboard.scss";

import { Row, Col } from 'react-bootstrap';
import axios from "axios";
// Below is for import the components
import InternetChecking from "../Student/Reusablecomponents/Network";
import CopyRight from "../Student/Reusablecomponents/Copyright";
import { AssessmentName, NumberToRoman } from "../Student/Reusablecomponents/RegularFunctions";
import NCLOGO from "../Student/Assests/Images/NCLogo.png";

const SchoolPerformance = (props) => {

    const [PerformanceOne, SetPerformanceOne] = useState();
    const [Subjects, SetSubjects] = useState();
    const [Sections, SetSections] = useState();

    const [Performace112, SetPerformace112] = useState();
    const [Subjects112, SetSubjects112] = useState();
    const [Sections112, SetSections112] = useState();

    const processData = (data) => {
        const groupedData = {};
        data.forEach(item => {
            if (!groupedData[item.grade]) {
                groupedData[item.grade] = { grade: item.grade, subjects: {} };
            }
            groupedData[item.grade].subjects[item.subject] = item;
        });
        return groupedData;
    };

    const SubjectGradeWisePerformanceReport = async () => {
        await axios.get(process.env.REACT_APP_API_BASE_URL + `/Principal/GetSubjectGradeWisePerformanceReport?SchoolId=${props.schoolId}&ContestCreationId=${props.contestCreationId}&AssessmentType=${props.assessmentType}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                if (res.data?.[0].grade) {
                    SetPerformanceOne(processData(res.data));
                    SetSubjects([...new Set(res.data.map(item => item.subject))]);
                    SetSections([...new Set(res.data.flatMap(item => Object.keys(item).filter(key => key !== 'subject' && key !== 'grade')))])
                }
                else {
                    SetPerformanceOne();
                }
            })
            .catch((err) => console.log(err))
    };


    const PerformanceReportForGrade11And12 = async () => {
        await axios.get(process.env.REACT_APP_API_BASE_URL + `/Principal/GetPerformanceReportForGrade11And12?SchoolId=${props.schoolId}&ContestCreationId=${props.contestCreationId}&AssessmentType=${props.assessmentType}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                if (res.data?.[0].grade) {
                    SetPerformace112(processData(res.data));
                    SetSubjects112([...new Set(res.data.map(item => item.subject))]);
                    SetSections112([...new Set(res.data.flatMap(item => Object.keys(item).filter(key => key !== 'subject' && key !== 'grade')))])
                }
                else {
                    SetPerformace112();
                }
            })
            .catch(err => console.log(err))

    };
    useEffect(() => {
        SubjectGradeWisePerformanceReport();
        PerformanceReportForGrade11And12();
    }, [])

    const GetPColor = (e) => {
        switch (e) {
            case "English":
                return "#0B6EE3"
            case "Mathematics":
                return "#3DA663"
            case "Biology":
                return "#9951BB"
            case "BioTechnology":
                return "#EE649E"
            default:
                return "#F59E3C"
        }
    };
    const moveLastToFirst = (sub) => {
        if (sub.length > 0) {
            const newItems = [...sub];
            const lastItem = newItems.pop(); // Remove the last item
            newItems.unshift(lastItem); // Add it to the beginning
            return (newItems)
        }
    };
    const renderTable = (data, Subjects, Sections) => (
        <table className="Principle-Table">
            <thead>
                <tr>
                    <th rowSpan="2">Grade</th>
                    {Subjects?.map((subject, index) => (
                        <th colSpan={Sections.length} key={index} style={{ backgroundColor: GetPColor(subject), color: "#FFF" }}>{subject}</th>
                    ))}
                </tr>
                <tr>
                    {Subjects?.flatMap((subject, subjectIndex) =>
                        moveLastToFirst(Sections)?.map((section, sectionIndex) => (
                            <th key={`section-${subjectIndex}-${sectionIndex}`} style={{ color: GetPColor(subject), textTransform: "capitalize" }}>Sec - {section}</th>
                        ))
                    )}
                </tr>
            </thead>
            <tbody>
                {data && Object.values(data)?.map((item, index) => (
                    <tr key={index}>
                        <td>{NumberToRoman(item.grade)}</td>
                        {Subjects.flatMap((subject, subjectIndex) => {
                            const subjectData = item.subjects[subject];
                            return moveLastToFirst(Sections)?.map((section, idx) => (
                                <td key={`${idx}-${subjectIndex}`}>{subjectData[section] !== undefined ? subjectData[section] + "%" : '-'}</td>
                            ));
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    );

    return (
        <>


<div className="container-fluid Header-Maindiv">

                <Row className="alignitems">
                    <Col ><img src={NCLOGO} alt="Logo" className="LOGO" /> </Col>

                    

                </Row>

            </div>





            <div className="TeacherBgImage dflex flexd-column " style={{ height: "88vh" }}>

                <InternetChecking />

                <div className="dflex JSBetween alignitems ">
                    <div className="PrincipleTitle">{AssessmentName(props.assessmentType)} - Section wise performance (Grades VI to XII)</div>

                </div>
                <div className="container-fluid mt-2" >
                    <Row>
                        <Col>
                            <div className="Table-Card">
                                {PerformanceOne ? renderTable(PerformanceOne, Subjects, Sections) : <div className="NoData-Message ">{process.env.REACT_APP_Nodata_Found}</div>}
                            </div>
                        </Col>

                    </Row>
                </div>
                <div className="container-fluid mt-4">
                    <Row >
                        <Col >
                            <div className="Table-Card">

                                {Performace112 ? renderTable(Performace112, Subjects112, Sections112) : <div className="NoData-Message ">{process.env.REACT_APP_Nodata_Found}</div>}

                            </div>
                        </Col>

                    </Row>
                </div>

                <div className="container-fluid mt-4">
                        <Row>
                            <div className="Notice">
                                <h5>Note</h5>
                                <div>
                                    <ol>
                                    <li><b>Section - X</b> - Students that did not select a section.</li>
                                    <li>Swipe <b>left</b> to see results for <b>Section A and Section B</b>.</li>
                                    </ol>
                                </div>
 
                            </div>
                        </Row>
                    </div>

                <div className="COpyright-link"><CopyRight /> </div>
            </div>

        </>)
}
export default SchoolPerformance;